import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/context/auth-context";
import { isSuperAdmin, UserRole } from "@utils/rbac";
import ContractGateModal from "@components/contracts/ContractGateModal";

interface PrivateRouteProps {
  children: React.ReactNode;
  roles?: UserRole[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, roles }) => {
  const { role, isAuthenticated, isBootstrapping } = useAuth();

  if (isBootstrapping) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (roles && roles.length > 0 && (!role || !roles.includes(role))) {
    return <Navigate to={isSuperAdmin(role) ? "/unternehmen" : "/arbeiten"} replace />;
  }

  return (
    <>
      <ContractGateModal />
      {children}
    </>
  );
};

export default PrivateRoute;
